import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");

export const formatTime = (date: Date) => {
  const hour = date.getHours();
  const minute = date.getMinutes();

  return [hour, minute].map(formatNumber).join(":");
};

export const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return [year, month, day].map(formatNumber).join("-");
};

export const formatLocalDate = (date: Date) => {
  return moment(date).format("MMMDo dddd");
};

export const formatLocalTime = (date: Date | undefined) => {
  return moment(date).format("MMMDo dddd Ah:mm");
};

export const formatLocalDateTime = (date: Date | undefined) => {
  return moment(date).format("MMMDo dddd H:mm");
};

export const toDateObject = (date?: string, time?: string) => {
  if (date && time) {
    return moment(`${date}T${time}`).toDate();
  }
  return undefined;
};

export const toLocalDateTimeString = (date?: string, time?: string) => {
  const result = toDateObject(date, time);
  return result ? formatLocalDateTime(result) : "";
};

export const toDateISOString = (date?: string, time?: string) => {
  const result = toDateObject(date, time);
  return result ? result.toISOString() : "";
};

const formatNumber = (n: number) => {
  const s = n.toString();
  return s[1] ? s : "0" + s;
};

export const json2Form = (json: any) => {
  const str = [];
  for (const p in json) {
    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(json[p]));
  }
  return str.join("&");
};
